


import { Component, Prop, Vue } from "vue-property-decorator";

import { Plan, Price, PriceAudit } from "App/Models";
import { PriceAudit as PriceAuditService } from "App";

import PopupWindow from "Web/Components/Popup/Window.vue";

@Component({
    components: {
        PopupWindow
    }
})
export default class PriceHistory extends Vue {
    /* Price-level history: pass Record. Plan-level history (every price of the plan, including
       deleted ones): pass Plan instead. Exactly one of the two is provided. */
    @Prop() readonly Record?: Price;
    @Prop() readonly Plan?: Plan;

    private entries: PriceAudit[] = [];
    private loading: boolean = true;

    private get isPlanLevel(): boolean {
        return this.Plan !== undefined;
    }

    private get title(): string {
        if( this.Plan !== undefined )
            return this.Plan.Name !== undefined ? this.Plan.Name : "";

        return ( this.Record !== undefined && this.Record.Name !== undefined )
            ? this.Record.Name
            : "";
    }

    private async mounted(): Promise<void> {
        const [ entries ] = ( this.Plan !== undefined )
            ? await PriceAuditService.FindByPlan( this.Plan.Id )
            : await PriceAuditService.FindByPrice(
                this.Record !== undefined ? this.Record.Id : -1
            );

        this.entries = entries;
        this.loading = false;
    }

    private actionLabel( action: string ): string {
        return this.$t( `PRICEAUDIT_action${action}` ).toString();
    }

    private actionClass( action: string ): string {
        return `c-price-history__action--${action.toLowerCase()}`;
    }

    /* Map a stored field key to a human label. Tier keys ("Tier:2:UnitPrice") become
       "Palier 2 — Prix unitaire" by reusing the per-field labels. */
    private fieldLabel( field?: string ): string {
        if( field === undefined || field === "" )
            return "—";

        const tier = field.match( /^Tier:(\d+):(\w+)$/ );

        if( tier !== null ) {
            const label = this.$t( `PRICEAUDIT_field${tier[ 2 ]}` ).toString();

            return this.$t(
                "PRICEAUDIT_tier",
                { index: tier[ 1 ], field: label }
            ).toString();
        }

        return this.$t( `PRICEAUDIT_field${field}` ).toString();
    }

    private formatValue( value?: string ): string {
        if( value === undefined || value === "" )
            return "—";

        if( value === "true" )
            return this.$t( "GLOBAL_yes" ).toString();

        if( value === "false" )
            return this.$t( "GLOBAL_no" ).toString();

        return value;
    }
}
